import script from "./ConfiguracaoCatraca.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfiguracaoCatraca.vue?vue&type=script&setup=true&lang=js"

import "./ConfiguracaoCatraca.vue?vue&type=style&index=0&id=be4399ac&scoped=true&lang=css"

import exportComponent from "/home/runner/work/santo_cartao_adm_master/santo_cartao_adm_master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be4399ac"]])

export default __exports__